import { CartLinesUpdateEvent } from '@shopify/events';

let busy = false;
async function mutate(control, subscription) {
  if (busy || document.querySelector('cart-items-component.cart-items-disabled')) {
    if (subscription) control.checked = !control.checked;
    return;
  }
  busy = true;
  const container = control.closest('.xomd-cart-subscription, .xomd-cart-upsell');
  const status = container.querySelector('[data-cart-action-status]');
  const root = window.Shopify?.routes?.root || '/';
  const deferred = CartLinesUpdateEvent.createPromise();
  deferred.promise.catch(() => {});
  document.dispatchEvent(new CartLinesUpdateEvent({
    action: subscription ? 'update' : 'add', context: 'cart',
    lines: subscription ? [{ id: control.dataset.lineKey }] : [{ merchandiseId: control.dataset.cartUpsell, quantity: 1 }],
    promise: deferred.promise,
  }));
  control.disabled = true;
  status.textContent = 'Updating…';
  const cartComponents = document.querySelectorAll('cart-items-component');
  cartComponents.forEach(component => component.classList.add('cart-items-disabled'));
  try {
    const sections = [...new Set(Array.from(document.querySelectorAll('cart-items-component'), el => el.dataset.sectionId).filter(Boolean))].slice(0, 5);
    let payload = { items: [{ id: Number(control.dataset.cartUpsell), quantity: 1 }] };
    if (subscription) {
      // Read quantity immediately before mutation; never restore a stale rendered quantity.
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Unable to read your cart. Please try again.');
      const cart = await response.json();
      const line = cart.items.find(item => item.key === control.dataset.lineKey);
      if (!line) throw new Error('This item has changed. Refresh your cart and try again.');
      payload = { id: line.key, quantity: line.quantity, selling_plan: control.checked ? Number(control.dataset.planId) : null };
    }
    const response = await fetch(`${root}cart/${subscription ? 'change' : 'add'}.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...payload, sections, sections_url: location.pathname }),
    });
    const result = await response.json();
    if (!response.ok || result.errors) throw new Error(result.description || 'Unable to update your cart. Please try again.');
    let cart = result;
    if (!subscription) {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Item added. Please refresh to see your updated cart.');
      cart = await response.json();
    }
    deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { sections: result.sections, items: cart.items, itemCount: cart.item_count, source: 'xomd-cart-actions' } });
    status.textContent = 'Updated';
  } catch (error) {
    deferred.reject(error);
    if (subscription) control.checked = !control.checked;
    status.textContent = error.message;
  } finally {
    cartComponents.forEach(component => component.classList.remove('cart-items-disabled'));
    control.disabled = false;
    busy = false;
  }
}
document.addEventListener('change', event => {
  if (event.target.matches('[data-cart-subscription]')) mutate(event.target, true);
});
document.addEventListener('click', event => {
  const button = event.target.closest('[data-cart-upsell]');
  if (button) mutate(button, false);
});
